
import monev_home from '@/components/monev/home/monev_home'


import monev_lap_instrumen_guru from '@/components/monev/laporan/lap_instrumen_guru/lap_instrumen_guru'
import monev_lap_instrumen_komite_sekolah from '@/components/monev/laporan/lap_instrumen_komite_sekolah/lap_instrumen_komite_sekolah'
import monev_lap_instrumen_ks_bendahara from '@/components/monev/laporan/lap_instrumen_ks_bendahara/lap_instrumen_ks_bendahara'

import monev_lihat_lap_instrumen_ks_bendahara from '@/components/monev/laporan/lap_instrumen_ks_bendahara/lap_instrumen_ks_bendahara'

import monev_lap_instrumen_verifikasi_dapodik_sma from '@/components/monev/laporan/lap_instrumen_verifikasi_dapodik/lap_instrumen_verifikasi_dapodik_sma/lap_instrumen_verifikasi_dapodik_sma'
import monev_lap_instrumen_verifikasi_dapodik_smk from '@/components/monev/laporan/lap_instrumen_verifikasi_dapodik/lap_instrumen_verifikasi_dapodik_smk/lap_instrumen_verifikasi_dapodik_smk'

import monev_ver_instrumen_guru from '@/components/monev/verifikasi/ver_instrumen_guru/ver_instrumen_guru'
import monev_ver_instrumen_komite_sekolah from '@/components/monev/verifikasi/ver_instrumen_komite_sekolah/ver_instrumen_komite_sekolah'
import monev_ver_instrumen_ks_bendahara from '@/components/monev/verifikasi/ver_instrumen_ks_bendahara/ver_instrumen_ks_bendahara'
import monev_ver_instrumen_verifikasi_dapodik_sma from '@/components/monev/verifikasi/ver_instrumen_verifikasi_dapodik/ver_instrumen_verifikasi_dapodik_sma/ver_instrumen_verifikasi_dapodik_sma'
import monev_ver_instrumen_verifikasi_dapodik_smk from '@/components/monev/verifikasi/ver_instrumen_verifikasi_dapodik/ver_instrumen_verifikasi_dapodik_smk/ver_instrumen_verifikasi_dapodik_smk'

import monev_login from '@/components/auth/monev_login'
import monev_signin from '@/components/auth/monev_signin'

import hasil_monev_bos from '@/components/monev/analisis/hasil_monev_bos'
import hasil_monev_dapodik from '@/components/monev/analisis/hasil_monev_dapodik'
import hasil_monev_snp from '@/components/monev/analisis/hasil_monev_snp'

function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/dashboard');
    } else {
      next();
    }
  }
  
  function isLoggedIn(to, from, next) {
    if (localStorage.token) {
      next();
    } else {
      next('/monev_login');
    }
  }
  
  var routes = [
  
  // ============================= MONEV ========================================================
  {
    path: '/monev_login',
    name: '/monev_login',
    component: monev_login,
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/monev_signin',
    name: '/monev_signin',
    component: monev_signin
  },
  {
    path: '/monev_home',
    name: 'monev_home',
    component: monev_home
  },
  
  
  
  
  
  // LAPORAN
  
  {
    path: '/monev_lap_instrumen_guru',
    name: 'monev_lap_instrumen_guru',
    component: monev_lap_instrumen_guru
  },
  {
    path: '/monev_lap_instrumen_komite_sekolah',
    name: 'monev_lap_instrumen_komite_sekolah',
    component: monev_lap_instrumen_komite_sekolah
  },
  {
    path: '/monev_lap_instrumen_ks_bendahara',
    name: 'monev_lap_instrumen_ks_bendahara',
    component: monev_lap_instrumen_ks_bendahara
  },
  {
    path: '/monev_lihat_lap_instrumen_ks_bendahara',
    name: 'monev_lihat_lap_instrumen_ks_bendahara',
    component: monev_lihat_lap_instrumen_ks_bendahara
  },
  {
    path: '/monev_lap_instrumen_verifikasi_dapodik_sma',
    name: 'monev_lap_instrumen_verifikasi_dapodik_sma',
    component: monev_lap_instrumen_verifikasi_dapodik_sma
  },
  {
    path: '/monev_lap_instrumen_verifikasi_dapodik_smk',
    name: 'monev_lap_instrumen_verifikasi_dapodik_smk',
    component: monev_lap_instrumen_verifikasi_dapodik_smk
  },
  
  // VERIFIKASI
  {
    path: '/monev_ver_instrumen_guru',
    name: 'monev_ver_instrumen_guru',
    component: monev_ver_instrumen_guru
  },
  {
    path: '/monev_ver_instrumen_ks_bendahara',
    name: 'monev_ver_instrumen_ks_bendahara',
    component: monev_ver_instrumen_ks_bendahara
  },
  {
    path: '/monev_ver_instrumen_komite_sekolah',
    name: 'monev_ver_instrumen_komite_sekolah',
    component: monev_ver_instrumen_komite_sekolah
  },
  {
    path: '/monev_ver_instrumen_verifikasi_dapodik_sma',
    name: 'monev_ver_instrumen_verifikasi_dapodik_sma',
    component: monev_ver_instrumen_verifikasi_dapodik_sma
  },
  {
    path: '/monev_ver_instrumen_verifikasi_dapodik_smk',
    name: 'monev_ver_instrumen_verifikasi_dapodik_smk',
    component: monev_ver_instrumen_verifikasi_dapodik_smk
  },
  
  
  // ANALISIS
  {
    path: '/hasil_monev_bos',
    name: 'hasil_monev_bos',
    component: hasil_monev_bos
  },
  {
    path: '/hasil_monev_dapodik',
    name: 'hasil_monev_dapodik',
    component: hasil_monev_dapodik
  },
  {
    path: '/hasil_monev_snp',
    name: 'hasil_monev_snp',
    component: hasil_monev_snp
  },
  // ============================= MONEV ========================================================
  
  
  ]


  export default routes